/**
 * Gift Message — Client-side logic for gift pack product pages.
 * Handles checkbox toggle, character counter, and clears value on submit
 * if checkbox is unchecked so no empty property is sent.
 */
(function () {
  'use strict';

  var MAX_LENGTH = 150;

  function init() {
    var container = document.querySelector('[data-gift-message]');
    if (!container) return;

    var checkbox = container.querySelector('#gift-message-toggle');
    var fields = container.querySelector('.gift-message__fields');
    var icon = container.querySelector('.gift-message__toggle-icon');
    var textarea = container.querySelector('#gift-message-text');
    var charCount = container.querySelector('.gift-message__char-count');

    if (!checkbox || !fields || !textarea) return;

    // Toggle open/close
    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        fields.classList.add('gift-message__fields--visible');
        if (icon) icon.classList.add('gift-message__toggle-icon--open');
        textarea.disabled = false;
        textarea.focus();
      } else {
        fields.classList.remove('gift-message__fields--visible');
        if (icon) icon.classList.remove('gift-message__toggle-icon--open');
        textarea.disabled = true;
        textarea.value = '';
        if (charCount) {
          charCount.textContent = '0 / ' + MAX_LENGTH;
          charCount.classList.remove('gift-message__char-count--limit');
        }
      }
    });

    // Live character counter
    if (charCount) {
      textarea.addEventListener('input', function () {
        var len = textarea.value.length;
        if (len > MAX_LENGTH) {
          textarea.value = textarea.value.substring(0, MAX_LENGTH);
          len = MAX_LENGTH;
          charCount.classList.add('gift-message__char-count--limit');
        } else {
          charCount.classList.remove('gift-message__char-count--limit');
        }
        charCount.textContent = len + ' / ' + MAX_LENGTH;
      });
    }

    // On form submit: if checkbox unchecked, blank textarea so no empty property is serialised
    var form = container.closest('form[action*="/cart/add"]');
    if (!form) {
      var wrapper = container.closest('[data-product-form]');
      if (wrapper) form = wrapper.querySelector('form');
    }

    if (form) {
      form.addEventListener('submit', function () {
        if (!checkbox.checked) {
          textarea.value = '';
        }
      }, true); // capture so it runs before theme handlers

      // Also cover AJAX button click path (Flex theme .ajax-submit)
      var addBtn = form.querySelector('.button--add-to-cart');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!checkbox.checked) {
            textarea.value = '';
          }
        }, true);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
